export class HttpContextConfig {
    noSpinner: boolean;

    constructor() {
        this.noSpinner = false;
    }
}